import React from 'react'
import { chevron_right, consumed_from_pv, consumption_today, revenue_today, yield_today } from '../../Images/Icons';
import { useNavigate } from 'react-router-dom';
import css from './HomePage.module.scss'

const StatisticCard = (props) => {    
    const navigation = useNavigate();
    const onStatistic = () => {
        navigation('/home/statistic');
    }
    const total_consumption = localStorage.getItem("total_consumption");
    const total_revenue_today = localStorage.getItem("revenue_today");

    // console.log('stat', props.data)
    if (!props.data) {
        return (
            
            <div style={{ marginTop: 20 }}>
                <div className={css.wrap_static} style={{height:182}}>
                    <div class="loading element title_skeleton"></div>
                    <div class="loading element content_skeleton"></div>
                </div>
            </div>
        )
    }

    return (
        <div style={{ marginTop: 40 }}>
            
            <div className={css.wrap_static}>
                <div onClick={onStatistic} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '0 18px', height: 40, cursor: 'pointer' }}>
                    <span style={{ fontSize: 18, fontWeight: 600, color: '#292929' }}>Statistic</span>
                    <div><img src={chevron_right} alt="" style={{ width: 24, height: 24 }} /></div>
                </div>
                <div style={{ margin: '6px 24px' }}>
                    <div style={{ display: 'flex' }}>
                        <div style={{ display: 'flex', flex: 1, justifyContent: 'start', alignItems: 'center', cursor:'pointer' }} onClick={()=> navigation('/home/statistic')}>
                            <img src={yield_today} alt="" style={{ width: 32, height: 32, marginRight: 12 }} />
                            <div>
                                <div style={{ fontSize: 16, color: '#292929', fontWeight: 500 }}>{props.data.yield_today} <span style={{ fontSize: 12, color: '#8A93A6', fontWeight: 500 }}>kWh</span></div>
                                <div style={{ fontSize: 12, color: '#8A93A6', fontWeight: 500 }}>Yield today</div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', flex: 1, justifyContent: 'start', alignItems: 'center', cursor:'pointer' }} onClick={()=> navigation('/home/statistic')}>
                            <img src={revenue_today} alt="" style={{ width: 32, height: 32, marginRight: 12 }} />
                            <div>
                            <div style={{ fontSize: 16, color: '#292929', fontWeight: 500 }}><span style={{ fontSize: 12, color: '#8A93A6', fontWeight: 500 }}>Rp</span> {new Intl.NumberFormat('de-DE').format(parseInt(total_revenue_today).toFixed(0))} </div>
                                <div style={{ fontSize: 12, color: '#8A93A6', fontWeight: 500 }}>Revenue today</div>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', marginTop: 16 }}>
                        <div style={{ display: 'flex', flex: 1, justifyContent: 'start', alignItems: 'center' }}>
                            <img src={consumption_today} alt="" style={{ width: 32, height: 32, marginRight: 12 }} />
                            <div>
                                <div style={{ fontSize: 16, color: '#292929', fontWeight: 500 }}>{parseInt(total_consumption).toFixed(0)} <span style={{ fontSize: 12, color: '#8A93A6', fontWeight: 500 }}>kWh</span></div>
                                <div style={{ fontSize: 12, color: '#8A93A6', fontWeight: 500 }}>Consumption <br />today</div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', flex: 1, justifyContent: 'start', alignItems: 'center' }}>
                            <img src={consumed_from_pv} alt="" style={{ width: 32, height: 32, marginRight: 12 }} />
                            <div>
                                <div style={{ fontSize: 16, color: '#292929', fontWeight: 500 }}>{props.data.consume_pv} <span style={{ fontSize: 12, color: '#8A93A6', fontWeight: 500 }}>kWh</span></div>
                                <div style={{ fontSize: 12, color: '#8A93A6', fontWeight: 500 }}>Consumed <br />from PV</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StatisticCard